<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid class="px-6">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on purchase forms" v-model="product.buyingDescription" :rules="[fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
      </v-row>

      <v-row dense v-if="vendors && vendors.length>0">
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete outlined dense hide-details clearable label="Preferred supplier" v-model="product.preferredVendorId" :items="vendors" item-value="id" item-text="name"/>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12" lg="9">
          <supplier-costing :vendors="product.vendors" :allVendors="vendors" :taxes="taxes" :default-sku="product.sku" units="Case" :suppliesInBond="true"/>
        </v-col>
      </v-row>
    </v-container>
   </v-form>
</template>

<script>
import SupplierCosting from '@/components/SupplierCosting'

export default {
  name: 'InventoryProductsEditBuying',
  components: {SupplierCosting},
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true},
  },
  data() {
    return {
      valid: true,
      vendors: []
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  async created() {
    if (this.$store.getters.company.permissions.includes('buying'))
      this.$lazyListLoad(this.vendors, 'vendors2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
  },
  watch: {
    item: {
      handler() {this.$emit('input', true);},
      immediate: true,
      deep: true
    }
  }
}
</script>